module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BoldCond.fc6909c.ttf";